<template>
  <span v-if="valueDelta" :class="getDeltaClass()" class="delta-arrow">
    <font-awesome-icon :icon="getIcon()"/>
    {{ valueDelta | formatNullablePercent(decimalPlaces) }}%
  </span>
</template>

<script>
export default {
  props: {
    valueDelta: {
      required: true,
    },
    decimalPlaces: {
      type: Number,
      default: 0,
    },
  },

  filters: {
    formatNullablePercent(value, decimalPlaces) {
      if (value === null || value === undefined) {
        return '-';
      }

      return (value * 100).toFixed(decimalPlaces).replace('.', ',');
    },
  },

  methods: {
    getIcon() {
      return 'long-arrow-alt-' + this.getIconSuffix();
    },

    getIconSuffix() {
      return this.valueDelta < 0 ? 'down' : 'up'
    },

    getDeltaClass() {
      return this.valueDelta > 0 ? 'red' : 'green';
    },
  },
}
</script>

<style>
.green {
  color: green;
}

.red {
  color: red;
}
.delta-arrow {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/VectorWidgets/ux/Delta.vue